// extracted by mini-css-extract-plugin
export default {"tx":"_88bb7197d9","line":"bd462c6a81"};